// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.active-expansion[data-v-bbfd3b84] {\r\n  -webkit-transform: rotate(-180deg);\r\n          transform: rotate(-180deg);\n}\r\n", ""]);
// Exports
module.exports = exports;
